import { render, staticRenderFns } from "./DataSources.vue?vue&type=template&id=8cfd8ee2&"
import script from "./DataSources.vue?vue&type=script&lang=ts&"
export * from "./DataSources.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports